<template>
  <div>
    <transition
      name="fade"
      v-if="!loaderFinished || (!global.loadedItems.images  || !global.loadedItems.fonts)"
    >
      <SiteLoader @setLoaderFinished="setLoaderFinished" />
    </transition>
    <transition-group name="fade" v-else-if="firstMount">
      <!-- <TopNav key="2" v-if="windowWidth > 992 && navActive" /> -->
      <MobileNav key="2" v-if="navActive" />
      <div class="sections" key="3">
        <router-view />
      </div>
    </transition-group>
  </div>
</template>

<script>
  import SiteLoader from "@/components/global/SiteLoader";
  import TopNav from "@/components/Layout/TopNav";
  import MobileNav from "@/components/Layout/MobileNav";
  import { mapActions, mapState } from "vuex";

  export default {
    name: "Layout",
    components: {
      SiteLoader,
      TopNav,
      MobileNav
    },
    computed: {
      ...mapState(["global"])
    },
    data() {
      return {
        firstMount: false,
        loaderFinished: false,
        mobileActive: false,
        windowWidth: null,
        navActive: false
      };
    },
    watch: {
      $route(to, from) {
        if (to.name === "LandingVideo") {
          this.navActive = false
        } else {
          this.navActive = true
        }
      }
    },
    mounted() {
      this.firstMount = true;
      
      this.windowWidth = window.innerWidth;

      window.addEventListener(
        "resize",
        () => {
          this.windowWidth = window.innerWidth;
        },
        false
      );

      let currentRoute = this.$route.name;

      if (currentRoute === "LandingVideo") {
        this.navActive = false
      } else {
        this.navActive = true
      }
    },
    methods: {
      setLoaderFinished() {
        this.loaderFinished = true;
      },
      ...mapActions(["setIsMobile"])
    }
  };
  </script>

  <style lang="scss" scoped>
  /* Fade Transition */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 2s ease-in-out;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>